import { useState } from 'react'
import { useDispatch } from 'react-redux'

// Actions
import { actions as audioActions } from 'modules/audio/actions'

// Components
import { Slider, IconVolume1, IconVolume2, IconVolumeMute } from '@tracklib/kit'

// Utils
import { safeLocalStorage as localStorage } from 'utils'

import styles from './volumecontrol.css'

const VolumeControl = () => {
  const dispatch = useDispatch()
  const [volume, setVolume] = useState(+localStorage.getItem('volume') || 1)
  const [prevVolume, setPrevVolume] = useState<number | null>(null)

  const renderIcon = (): JSX.Element => {
    if (volume > 0.5) {
      return <IconVolume2 />
    }
    if (volume > 0) {
      return <IconVolume1 />
    }
    return <IconVolumeMute />
  }

  const handleUpdate = (vol: number) => {
    setVolume(vol)
    localStorage.setItem('volume', String(vol))
    return dispatch(audioActions.updateVolume(vol))
  }

  const handleClick = () => {
    if (volume > 0) {
      setPrevVolume(volume)
      handleUpdate(0)
    } else {
      handleUpdate(prevVolume || 1)
    }
  }

  return (
    <div className={styles.wrapper}>
      <button onClick={handleClick} className={styles.button}>
        {renderIcon()}
      </button>
      <div className={styles.rollover}>
        <Slider
          min={0}
          max={1}
          values={[volume]}
          step={0.05}
          onUpdate={value => handleUpdate(value[0])}
          hideHandleValue
          vertical
          className={styles.slider}
        />
      </div>
    </div>
  )
}

export default VolumeControl
